// extracted by mini-css-extract-plugin
export default {"statsH":"SingleFixtureStats_statsH__BL1mK","statsBar":"SingleFixtureStats_statsBar__NyHew"};